import { FunctionComponent } from 'react'
import { Typography, rucksack } from '@black-bear-energy/rucksack'
import {
  isBBEUserOrSuperAdmin,
  useAuthSettings,
  useUser,
} from '../../state/modules/auth'
import { useImpersonatingUser } from '../../state/modules/impersonations'

/**
 * Greets Black Bear users by their first name as defined in Auth0, and client users (or Black Bear
 * users impersonating a client) by the client's name as defined in Quickbase. Renders nothing until
 * the impersonation info has loaded, and falls back to "Welcome!" when there is no name to show.
 */
export const WelcomeHeader: FunctionComponent = () => {
  const user = useUser()
  const impersonatingUser = useImpersonatingUser()
  const { isLoading, entity } = useAuthSettings()

  if (isLoading || !user) {
    return null
  }

  const name =
    isBBEUserOrSuperAdmin(user) && !impersonatingUser
      ? user.given_name
      : entity?.entityName

  return (
    <Typography variant="h3" sx={{ color: rucksack.palette.text.primary }}>
      {name ? `Welcome, ${name}!` : 'Welcome!'}
    </Typography>
  )
}
